<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="item-select">
        <label>合同状态：</label>
        <el-select size="mini" v-model="filterStatus" placeholder="请选择">
          <el-option v-for="item in statusArr" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </div>
      <el-input style="margin-top:5px;" v-model="filterKey" size="mini" placeholder="你可以搜索合同名称/创建人"></el-input>
    </div>

    <div class="ball-loading" v-if="loading">
      <div class="k-ball-holder3">
        <div class="k-ball7a"></div>
        <div class="k-ball7b"></div>
        <div class="k-ball7c"></div>
        <div class="k-ball7d"></div>
      </div>
    </div>
    <div class="card-room" v-else>
      <div class="no-list" v-if="paginationData.length<1">
        <p>暂无与你相关的工程项目</p>
      </div>
      <div class="card-item" v-else v-for="item, i in paginationData">
        <div class="title">
          <!-- <div class="r">编号：{{item.number}}</div> -->
          <h3 class="name">{{item.name}}</h3>
        </div>
        <div class="info">
          <p class="status">当前进度：{{item.status}}</p>
          <p>{{item.deptName}}</p>
          <p>当前负责人：{{ item.leader.name+" - "+(item.leader.telephone?item.leader.telephone:item.leader.mobile) }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  export default {
    components: {},
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 列表
        loading: true,
        pageSize: 2000,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],

        // 筛选搜索
        filterKey: "",
        filterStatus: "全部",
        statusArr: ["全部", "新建完成", "招标中", "招标完成", "签订中", "签订完成", "实施中", "验收完成"],

      }
    },
    mounted() {
      this.getLists()
      // 获取项目组
      this.getTeam()
    },
    methods: {
      // 获取项目组
      getTeam() {
        ajax.post('/gc/project/team/list', '', (res) => {
          this.teamArr = [{
            id: 0,
            name: "全部"
          }]
          this.teamArr = this.teamArr.concat(res.vo.array)
        })
      },
      startCreate() {
        this.$router.push("/Project/Create")
      },
      projectDetail(row) {
        this.$router.push("/Project/Detail/" + row.id)
      },
      getUserList(users) {
        let _item = ""
        for (var i = 0; i < users.length; i++) {
          _item += '<span class="user-item">' + users[i].name + '</span>'
        }
        return _item
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterStatus != "全部" || this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]

            // 筛选状态
            let _filterStatus = true
            if (this.filterStatus != "全部") {
              if (this.filterStatus != _new.status) {
                _filterStatus = false
              }
            }
            if (_filterStatus) {
              if (_new.name.indexOf(this.filterName) != -1 || _new.creator.name.toLowerCase()
                .indexOf(this.filterKey.toLowerCase()) != -1) {
                this.filterData.push(_new)
              }
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/user/contract/list', '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'filterStatus'() {
        this.getFilterData()
      },
      'filterKey'() {
        this.getFilterData()
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/m/contractlist.vue